import DataQueries                 from '../graphql/Queries';
import occupationDialogModel       from '../schedule/OccupationDialogModel';
import { DefaultSchema }           from './SettingsModel';
import mainPageModel               from '../main-navigation/MainPageModel';
import { MasterDataSettingsModel } from './MasterDataSettingsModel';
import { OccupationSort }          from '../DataTypes';

export default class OccupationsSettingsModel extends MasterDataSettingsModel {
  constructor() {
    super('Occupation', 'occupations', occupationDialogModel);
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddOccupations;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditOccupations;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteOccupations;
  }

  protected async _load(filter: {search?: string}, sort?: OccupationSort) {
    const results = (await DataQueries.getOccupations(DefaultSchema + ' archived', filter, sort, this.paging.itemsPerPage, this.paging.currentPage));
    this.setItems(results.data);
    return results;
  }
}
